import { theme } from '@acorns/grove'
import styled from 'styled-components'

export const ProgressBarContainer = styled.div<{ percentage: number }>`
  width: 200px;
  height: 4px;
  background-color: ${theme.colors.primaryIvory};
  border-radius: 4px;
  position: relative;

  @media (max-width: ${theme.dimensions.breakpointsSmall}px) {
    width: 100px;
  }
  
  &:after {
    content: "";
    position: absolute;
    background: ${theme.colors.primaryGreen};
    top: 0;
    bottom: 0;
    left: 0;
    width: ${props => 100 - props.percentage}%;
  }
`
